{
  "BANNER": {
    "TITLE": "Connect with the right kind of care",
    "DESCRIPTION": "We take care of your every day and large healthcare needs. Take care of yourself and we will take care of the rest. Get your first month membership in just $29.99.",
    "BTNTEXT": "Get Started Now"
  },
  "FEATURE": {
    "TITLE": "Featured in"
  },
  "BENEFITS": {
    "TITLE": "Benefits you get",
    "DESCRIPTION": "Membership that puts control back in your hands, with a community behind you ",
    "BOX1": {
      "TITLE": "Peace of Mind",
      "DESCRIPTION": " Our members have full transparency and control over their medical decisions, with no long-term commitments."
    },
    "BOX2": {
      "TITLE": "Simple Model",
      "DESCRIPTION": "Discounted direct-pay rates for routine Everyday Care. Option to add HealthShare for large medical needs like ER visits, hospitalizations, pregnancy, etc."
    },
    "BOX3": {
      "TITLE": "No Restrictions",
      "DESCRIPTION": "No annual or lifetime caps on services. Nationwide access including global protection while traveling"
    }
  },
  "FEELBETTER": {
    "MINI_TITLE": "What we treat?",
    "TITLE": "How can we help you feel better?",
    "BOX1": {
      "TITLE": "Virtual Urgent Care",
      "DESCRIPTION": "Free 24/7 access to a doctor without the wait or cost of office visits."
    },
    "BOX2": {
      "TITLE": "Mental Health",
      "DESCRIPTION": "Free sessions with certified counselors to assist with the stressors of life."
    },
    "BOX3": {
      "TITLE": "Medications",
      "DESCRIPTION": "Up to 400 generic medications at no cost"
    },
    "BOX4": {
      "TITLE": "Complete Care",
      "DESCRIPTION": "Regardless of your medical needs, we have services to address all of them. "
    }
  },
  "BENIFITSMEMBERSHIP": {
    "MINI_TITLE": "What sets us apart",
    "TITLE": "Benefits of our membership",
    "BENIFIT1": "Free 24/7 Telemedicine access to a doctor, and mental health counselors",
    "BENIFIT2": "Nationwide community of direct-pay providers, across all aspects of healthcare",
    "BENIFIT3": "Simple app and workflows for everyone, not just some medical experts",
    "BENIFIT4": "No long term commitments with monthly plans to our member only community",
    "BENIFIT5": "Transparent pricing without need for approvals for all healthcare needs",
    "BENIFIT6": "24/7 customer support to assist with any questions"
  },
  "MONTHLYMEMBERSHIP": {
    "TITLE": "Get your monthly membership for only $29.99",
    "DESCRIPTION": "Comprehensive healthcare without the high costs of premiums and complexities of insurance" ,
    "BTNTEXT": "Get Started" 
  },
  "BLOG":{
    "MINI_TITLE": "Join the community",
    "TITLE": "Partner with us to provide meaningful benefits with control and transparency"
  },
  "TESTIMONIALS":{
    "MINI_TITLE": "Testimonials",
    "TITLE": "See how we've helped our members by hearing their stories."
  },
  "HELP":{
    "MINI_TITLE": "How can we help?",
    "TITLE": "Talk to us or explore our FAQ page",
    "BOX1": {
      "TITLE": "Talk to customer support",
      "DESCRIPTION": "Chat or speak to one of our member support representatives, 24/7. We strive to provide the very best care of all of our members."
    },
    "BOX2": {
      "TITLE": "Visit FAQ page",
      "DESCRIPTION": " We have answered many questions that you may have, and some that you may not have thought of yet! Connect with us if we can help in any way."
    }
  },
  "FAQS": {
        "MINI_TITLE": "How it works",
        "TITLE1": "Frequently",
        "TITLE2": "Asked Questions",
        "DESCRIPTION": "Need help? Reach out to our 24/7 customer support at  <a class='phone' href='tel:8449694325'>844-969-4325</a> and get the assistance you need.",
        "LINK": "Visit Faqs Page",
        "FAQ_LIST": [
            {
                "title": "Is WoW Health healthcare insurance?",
                "description": "No, WoW Health is not traditional health insurance. We're a portable membership plan that connects you with a network of healthcare providers at discounted rates. This means you can manage your health on your own terms, without being tied down to a specific employer plan."
            },
            {
                "title": "How can WoW Health accommodate my unpredictable work hours?",
                "description": "While we can't control your scheduling, WoW Health offers telemedicine options. With 24/7 access to doctors for minor injuries, illnesses, and prescriptions, you can receive care whenever it's most convenient for you. You can even get our services during your work breaks."
            },
            {
                "title": "Do I need to switch to WoW Health if I'm currently enrolled in another healthcare plan?",
                "description": "No, you don't need to switch. You can start your membership at WoW health at any time along with your health insurance or any other healthcare plan."
            },
            {
                "title": "How does WoW Health ensure transparent pricing?",
                "description": "We believe in upfront pricing to eliminate surprise bills and ensure transparency for our members. With WoW Health, you'll know exactly what you're paying for, allowing you to budget for your healthcare needs without any hidden costs or fees."
            },
            {
                "title": "If I get WoW Health, will I lose my government subsidy for a health plan?",
                "description": "No, since WoW Health is a membership and NOT an insurance plan, if you qualify for any government subsidy, you can continue to qualify for one. WoW Health can be a great supplement in this case for better routine care access."
            },
            {
                "title": "What kind of medications are included in the Plus and Comprehensive memberships with free medications?",
                "description": "WoW Health provides up to 400 generic medications at no cost to alleviate the financial burden of managing health conditions. These medications cover a wide range of common healthcare needs."
            },
            {
                "title": "Are mental health services available for coping with stress?",
                "description": "Absolutely, WoW Health provides free counseling sessions to address stress and burnout common in today's work environment, helping you manage your mental health effectively."
            },
            {
                "title": "What if I have questions or need assistance with my WoW Health plan?",
                "description": "Our dedicated customer support team is here to help you every step of the way. Whether you have questions about your coverage, need assistance with booking appointments, or require support with accessing our telemedicine services, our team is just a phone call or message away at 844-969-4325."
            }
         ]
    },
  "language": "en"
}